<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fa fa-times-circle color-orange" />
        Cancelación de Tarjeta
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.date"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de cancelación."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="model.cardNumber"
            custom-error-msg="Favor indique el número de la tarjeta."
            :error="errors[0]"
            label="Número de Tarjeta:"
            type="number"
          />
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="model.reason"
            :clearable="false"
            custom-error-msg="Favor seleccionar razón de cancelación."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Razón:"
            :options="cancellationReasons"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div v-if="showBalance" class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required|money">
          <custom-input
            v-model.number="model.balance"
            custom-error-msg="Favor indique el balance de la tarjeta."
            :error="errors[0]"
            label="Balance:"
            placeholder="0.00"
            prepend-icon="fa fa-dollar-sign"
            prepend-icon-color="green"
            prepend-icon-type="success"
            type="number"
          />
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.comment"
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@/mixins/alert.mixin';
import { putCancellation } from '@/modules/shared/cardHandling.api';
import { getCardCancellationReasons } from '@/modules/shared/code.api.js';
import cardCancelReasons from '@/utils/constants/cardCancelReasons';
import moment from 'moment';
export default {
  name: 'CancelCard',
  components: {
    CustomInput,
    CustomTextArea,
    CustomDatePicker,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  bankRequestDate: {
    type: Date,
    default: null,
  },
  data: () => ({
    cancellationReasons: [],
    model: {},
  }),
  computed: {
    showBalance() {
      return this.model?.reason?.name !== 'Balance en 0';
    },
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  async mounted() {
    const { data: cancellationReasons } = await getCardCancellationReasons();
    this.cancellationReasons = cancellationReasons.filter(
      (item) => item.id != cardCancelReasons.Reclamacion
    );
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      this.model.cardNumber = this.model.cardNumber.replace(/-/g, '');
      await putCancellation(this.model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La cancelación ha sido realizada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import '@/shared/scss/config/_colors.scss';

::v-deep .input-group-prepend.success .input-group-text {
  background: map.get($colors, 'green') !important;
  color: map.get($colors, 'white') !important;
}
</style>
